/**
 * Description: 历史消息
 * User: <changyin>
 * Date: 2017-01-04
 * Copyright(c) 2017 Taobao.com
 * update:
 *  2017-01-04 @changyin 重构
 */
import events from 'events';
import $ from '@ali/tarzan-zepto';
import IScroll from 'iscroll';
import tpl from './tpl.html';
import util from '../../../lib/util';
import './style.scss';

const isPC = util.isPC();

export default class FirstMessage extends events {
  constructor(app) {
    super();
    this.app = app;
    this.init();
  }

  init() {
    const config = this.app.appConfig;
    const recommendData = config.get('recommend');
    this.emit('done');
    this.config = config;
    // 没有推荐数据，当然不展示 = =
    if (!recommendData) {
      return;
    }
    this.render();
  }

  /**
   * 整个渲染逻辑，先展示loading,结束之后remove loading，然后展示首问卡片
   * @memberOf FirstMessage
   */
  render() {
    this.renderLoading().then(() => {
      this.renderBoard();
    });
  }

  /**
   * 渲染loading
   * @returns
   * @memberOf FirstMessage
   */
  renderLoading() {
    const gifSrc = '//gw.alicdn.com/tfs/TB1FcUBQXXXXXXYXpXXXXXXXXXX-134-84.gif';
    const loadingTpl = `<img style="width:2.5em;margin-bottom:-6px;" src="${gifSrc}" />`;

    return new Promise((resolve) => {
      this.app.postMessage({
        type: 'robot',
        body: {
          text: loadingTpl,
        },
      }).then((res) => {
        this.app.view.body.append(res.body);
        setTimeout(() => {
          res.body.remove();
          resolve();
        }, 2500);
      });
    });
  }

  /**
   * 渲染首问卡片主体内容
   * @memberOf FirstMessage
   */
  renderBoard() {
    const config = this.app.appConfig;
    const data = config.get('recommend');
    // 渲染首问卡片
    const $node = $(tpl.render(data));
    this.$node = $node;
    if (data.list && data.list.length === 0) {
      $node.find('.J_Bannerlist').addClass('banner-only');
    }
    this.app.view.body.append($node);
    // 如果有banner，初始化iscroll
    if (data.banner && data.banner.length > 0) {
      this.initScroller(data, $node);
      // 开始自动滚动banner
      this.bannerScroller.scrollIntervalId = this.setAutoScroll();
    }
    this.bindEvents($node);
    // 滚动到最底部
    this.app.view.scrollToBottom();
  }

  bindEvents($node) {
    const tap = isPC ? 'click' : 'tap';
    $node.find('.J_Category').on(tap, ev => this.toggleCategory($node, ev));
    $node.find('.J_Blank').on(tap, ev => this.openLink($node, ev));
    $node.find('.J_SendText').on(tap, ev => this.sendText($node, ev));
    $node.find('.J_Banner ').on(tap, ev => this.openBanner($node, ev));
    // @忤合 看起来像是在用户触摸屏幕的时候停止滚动用
    this.pauseAutoScroller($node);
  }

  openBanner($node, ev) {
    const $target = $(ev.currentTarget);
    const href = $target.attr('href');
    if (href) {
      const link = document.createElement('a');
      link.setAttribute('href', href);
      link.setAttribute('target', '_blank');
      document.body.appendChild(link);
      $(link).trigger('click');
      setTimeout(() => {
        $(link).remove();
      }, 10);
    }
  }

  pauseAutoScroller($node) {
    const _this = this;
    if (this.bannerScroller) {
      $node.find('.J_Bannerlist').on('touchend', () => {
        if (_this.bannerScroller.scrollIntervalId) {
          window.clearInterval(_this.bannerScroller.scrollIntervalId);
        }
        _this.bannerScroller.scrollIntervalId = _this.setAutoScroll();
      });
    }
  }

  toggleCategory($node, ev) {
    const view = this.app.view;
    const $target = $(ev.currentTarget);
    const $li = $target.parent();
    const ext = {};

    if ($li.hasClass('alime-expand')) {
      $li.removeClass('alime-expand');
    } else {
      $node.find('.alime-expand').removeClass('alime-expand');
      $li.addClass('alime-expand');
    }
    $li.find('li').toggleClass('list-unfold');
    setTimeout(() => {
      if (view.body.isBottom()) {
        view.body.refresh();
        // view.body.scrollToBottom();
      }
    }, 100);
    ext.id = $target.attr('data-cid');
    ext.position = $node.find('.J_Category').index($target);
  }

  openLink($node, ev) {
    const $target = $(ev.currentTarget);
    const href = $target.attr('href');
    if (href) {
      const link = document.createElement('a');
      link.setAttribute('href', href);
      link.setAttribute('target', '_blank');
      document.body.appendChild(link);
      $(link).trigger('click');
      setTimeout(() => {
        $(link).remove();
      }, 10);
    }
  }

  sendText($node, ev) {
    const $target = $(ev.currentTarget);
    const text = $target.attr('data-text');
    this.app.view.footer.submit(text);
  }

  /**
   * 首页banner自动滚动
   * @return { id } setInterval的id
   */
  setAutoScroll() {
    let id = 0;
    const slideTime = this.app.param.slideTime || 6000;
    const bannerScroller = this.bannerScroller;
    const pageLength = bannerScroller.pages.length;
    if (pageLength > 1) {
      id = setInterval(() => {
        const currentPage = bannerScroller.currentPage.pageX;
        bannerScroller.next();
        if (currentPage >= (pageLength - 1)) {
          bannerScroller.goToPage(0, 0, 0);
        }
      }, slideTime);
    }
    return id;
  }

  /**
   * 初始化banner的iscroll
   * @param {any} data
   * @param {any} $node
   * @memberOf FirstMessage
   */
  initScroller(data, $node) {
    const num = data.banner.length;
    const pageWidth = $node.width();
    $node.find('.J_Banner').css({
      width: pageWidth,
      height: 110,
    });
    $node.find('.J_Scroller').css('width', pageWidth * num);
    $node.find('.J_Indicator').css('width', 12 * (num - 1) + 6);

    this.bannerScroller = new IScroll($node.find('.J_Bannerlist')[0], {
      scrollX: true,
      scrollY: false,
      momentum: false,
      snap: true,
      indicators: {
        el: $node.find('.J_Indicator')[0],
        resize: false,
      },
    });
    // 只有一个banner，不展示indicator
    if (num === 1) {
      $node.find('.J_Indicator').hide();
    }
  }

  resize() {
    const $node = this.$node;
    const config = this.app.appConfig;
    const data = config.get('recommend');
    const pageWidth = $node.width();
    const num = data.banner.length;
    $node.find('.J_Banner').css({
      width: pageWidth,
      height: 110,
    });
    $node.find('.J_Scroller').css('width', pageWidth * num);
    $node.find('.J_Indicator').css('width', 12 * (num - 1) + 6);
    if (data.banner && data.banner.length > 0) {
      this.initScroller(data, $node);
      // 开始自动滚动banner
      this.bannerScroller.scrollIntervalId = this.setAutoScroll();
    }
    this.bannerScroller.refresh();
  }
}



// WEBPACK FOOTER //
// ./src/app/module/firstmessage/firstmessage.js